<aside
  class="t1-rail"
  [class.t1-rail--pinned]="isPinned"
  [attr.aria-expanded]="isPinned"
>
  <!-- Brand -->
  <button type="button" class="t1-rail__logo t1-home-link" (click)="goHome()" [attr.aria-label]="'home' | translate">
    <span class="t1-rail__logo-orb">
      @if (tenantLogo) {
        <img [src]="tenantLogo" [alt]="tenantTitle" />
      } @else {
        {{ logoInitials }}
      }
    </span>
    <span class="t1-rail__logo-text">{{ tenantTitle }}</span>
  </button>

  <!-- Search -->
  <div class="t1-rail__search" (click)="$event.stopPropagation()">
    <label class="t1-rail__search-field">
      <span class="t1-rail__search-icon">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          aria-hidden="true"
        >
          <circle cx="11" cy="11" r="8" />
          <path d="m21 21-4.35-4.35" />
        </svg>
      </span>
      <input
        type="text"
        class="t1-rail__search-input"
        [value]="searchQuery"
        [placeholder]="'search_placeholder' | translate"
        [attr.aria-label]="'search' | translate"
        (input)="onSearchInput($event)"
        (focus)="onSearchFocus()"
        (blur)="onSearchBlur()"
      />
    </label>
  </div>

  <!-- Primary navigation -->
  <nav class="t1-rail__nav" [attr.aria-label]="'template1_sidebar_nav' | translate">
    @for (item of navItems; track item.id) {
      <button
        type="button"
        class="t1-rail__item"
        [class.t1-rail__item--active]="item.id === activeNavId"
        [attr.aria-current]="item.id === activeNavId ? 'page' : null"
        (click)="navigate(item)"
      >
        <span class="t1-rail__icon">
          <ng-container *ngTemplateOutlet="navIcon; context: { $implicit: item.id }"></ng-container>
        </span>
        <span class="t1-rail__label">{{ item.labelKey | translate }}</span>
        @if (item.hasLiveDot) {
          <span class="t1-rail__live-dot" aria-hidden="true"></span>
        }
      </button>
    }
  </nav>

  <!--
    Nav icons, declared once and rendered by both the desktop rail above and
    the mobile bottom bar below, so the two can never drift apart.
  -->
  <ng-template #navIcon let-id>
          @switch (id) {
            @case ('home') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                <polyline points="9 22 9 12 15 12 15 22" />
              </svg>
            }
            @case ('events') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <rect x="3" y="4" width="18" height="18" rx="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
              </svg>
            }
            @case ('videos') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <polygon points="23 7 16 12 23 17 23 7" />
                <rect x="1" y="5" width="15" height="14" rx="2" />
              </svg>
            }
            @case ('live') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <circle cx="12" cy="12" r="10" />
                <circle cx="12" cy="12" r="3" />
              </svg>
            }
            @case ('ranking') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
                <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
                <path d="M4 22h16" />
                <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
                <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
                <path d="M18 2H6v7a6 6 0 0 0 12 0V2z" />
              </svg>
            }
            @case ('rating') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
              </svg>
            }
            @case ('dashboard') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
            }
            @case ('membership') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <rect x="2" y="5" width="20" height="14" rx="2" />
                <line x1="2" y1="10" x2="22" y2="10" />
              </svg>
            }
            @case ('sub_licenses') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <polygon points="12 2 2 7 12 12 22 7 12 2" />
                <polyline points="2 17 12 22 22 17" />
                <polyline points="2 12 12 17 22 12" />
              </svg>
            }
          }
  </ng-template>

  <div class="t1-rail__divider"></div>

  <!-- Settings -->
  <div class="t1-rail__bottom">
    <button
      type="button"
      class="t1-rail__item"
      [class.t1-rail__item--active]="openPopup === 'language'"
      (click)="togglePopup('language', $event)"
      [attr.aria-label]="'language' | translate"
      [attr.aria-expanded]="openPopup === 'language'"
    >
      <span class="t1-rail__icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <circle cx="12" cy="12" r="10" />
          <line x1="2" y1="12" x2="22" y2="12" />
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
        </svg>
      </span>
      <span class="t1-rail__label">{{ 'language' | translate }}</span>
    </button>

    <button
      type="button"
      class="t1-rail__item"
      (click)="toggleTheme()"
      [attr.aria-label]="'switch_theme' | translate"
      [attr.aria-pressed]="isDark"
    >
      <span class="t1-rail__icon">
        @if (isDark) {
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
          </svg>
        } @else {
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <circle cx="12" cy="12" r="5" />
            <line x1="12" y1="1" x2="12" y2="3" />
            <line x1="12" y1="21" x2="12" y2="23" />
            <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
            <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
            <line x1="1" y1="12" x2="3" y2="12" />
            <line x1="21" y1="12" x2="23" y2="12" />
            <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
            <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
          </svg>
        }
      </span>
      <span class="t1-rail__label">{{ 'template1_sidebar_theme' | translate }}</span>
    </button>

    @if (isThemeSwitchAvailable) {
    <button
      type="button"
      class="t1-rail__item"
      [class.t1-rail__item--active]="openPopup === 'theme'"
      (click)="togglePopup('theme', $event)"
      [attr.aria-label]="'template1_sidebar_skin' | translate"
      [attr.aria-expanded]="openPopup === 'theme'"
    >
      <span class="t1-rail__icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z" />
          <circle cx="13.5" cy="6.5" r=".5" fill="currentColor" />
          <circle cx="17.5" cy="10.5" r=".5" fill="currentColor" />
          <circle cx="6.5" cy="12.5" r=".5" fill="currentColor" />
          <circle cx="8.5" cy="7.5" r=".5" fill="currentColor" />
        </svg>
      </span>
      <span class="t1-rail__label">{{ 'template1_sidebar_skin' | translate }}</span>
    </button>
    }

    <button
      type="button"
      class="t1-rail__item t1-text-size-trigger"
      [class.t1-rail__item--active]="openPopup === 'textsize'"
      (click)="togglePopup('textsize', $event)"
      [attr.aria-label]="'text_size' | translate"
      [attr.aria-expanded]="openPopup === 'textsize'"
    >
      <span class="t1-rail__icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M4 20 10 4l6 16" />
          <path d="M6.5 14h7" />
          <path d="M17 20h5" />
          <path d="M19.5 17.5v5" />
        </svg>
      </span>
      <span class="t1-rail__label">{{ 'text_size' | translate }}</span>
    </button>

    <button
      type="button"
      class="t1-rail__item"
      [class.t1-rail__item--active]="openPopup === 'profile'"
      (click)="togglePopup('profile', $event)"
      [attr.aria-label]="profileLabelKey | translate"
      [attr.aria-expanded]="openPopup === 'profile'"
    >
      <span class="t1-rail__icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
      </span>
      <span class="t1-rail__label">{{ profileLabelKey | translate }}</span>
    </button>
  </div>
</aside>

<!--
  ── Mobile shell (≤ $t1-bp-mobile) ──────────────────────────────────────────
  A phone gets a top bar plus a bottom nav instead of the floating rail; the
  rail is hidden and these are shown by media query alone. Both are rendered
  unconditionally rather than behind a resize listener: Angular cannot bind a
  media query, and a listener would add state that CSS already tracks for free.
  Every control below calls the same handler its rail twin does, so navigation,
  search, theme and the profile menu have exactly one implementation.
-->
<header class="t1-mtop" (click)="$event.stopPropagation()">
  @if (!isMobileSearchOpen) {
    <button type="button" class="t1-mtop__brand t1-home-link" (click)="goHome()" [attr.aria-label]="'home' | translate">
      <span class="t1-mtop__logo">
        @if (tenantLogo) {
          <img [src]="tenantLogo" [alt]="tenantTitle" />
        } @else {
          {{ logoInitials }}
        }
      </span>
      <span class="t1-mtop__title">{{ tenantTitle }}</span>
    </button>
  }

  <div class="t1-mtop__actions" [class.t1-mtop__actions--search-open]="isMobileSearchOpen">
    <!-- Same shared, collapsible search component/animation as the Events
         and Live Scorecard pages (`<stupa-common-search-bar>`) — expands
         inline in place of the icon instead of opening a separate sheet.
         The brand/other buttons above hide while it's expanded so it can
         take the full row, same "nothing else visible" intent as before. -->
    <stupa-common-search-bar
      class="t1-mtop__search"
      [searchQuery]="searchQuery"
      [searchPlaceholder]="'search_placeholder' | translate"
      [emitExpandedOnInlineLayout]="true"
      (searchChange)="onGlobalSearchChange($event)"
      (inputExpandedChange)="onMobileSearchExpandedChange($event)"
    ></stupa-common-search-bar>

    @if (!isMobileSearchOpen) {
      <button
        type="button"
        class="t1-mtop__btn t1-text-size-trigger"
        [class.t1-mtop__btn--on]="openPopup === 'textsize'"
        (click)="togglePopup('textsize', $event)"
        [attr.aria-label]="'text_size' | translate"
        [attr.aria-expanded]="openPopup === 'textsize'"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M4 20 10 4l6 16" />
          <path d="M6.5 14h7" />
          <path d="M17 20h5" />
          <path d="M19.5 17.5v5" />
        </svg>
      </button>

      <button
        type="button"
        class="t1-mtop__btn"
        (click)="toggleTheme()"
        [attr.aria-label]="'switch_theme' | translate"
        [attr.aria-pressed]="isDark"
      >
        @if (isDark) {
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
          </svg>
        } @else {
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <circle cx="12" cy="12" r="5" />
            <line x1="12" y1="1" x2="12" y2="3" />
            <line x1="12" y1="21" x2="12" y2="23" />
            <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
            <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
            <line x1="1" y1="12" x2="3" y2="12" />
            <line x1="21" y1="12" x2="23" y2="12" />
            <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
            <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
          </svg>
        }
      </button>

      @if (isThemeSwitchAvailable) {
      <button
        type="button"
        class="t1-mtop__btn"
        [class.t1-mtop__btn--on]="openPopup === 'theme'"
        (click)="togglePopup('theme', $event)"
        [attr.aria-label]="'template1_sidebar_skin' | translate"
        [attr.aria-expanded]="openPopup === 'theme'"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z" />
          <circle cx="13.5" cy="6.5" r=".5" fill="currentColor" />
          <circle cx="17.5" cy="10.5" r=".5" fill="currentColor" />
          <circle cx="6.5" cy="12.5" r=".5" fill="currentColor" />
          <circle cx="8.5" cy="7.5" r=".5" fill="currentColor" />
        </svg>
      </button>
      }

      <button
        type="button"
        class="t1-mtop__btn"
        [class.t1-mtop__btn--on]="openPopup === 'language'"
        (click)="togglePopup('language', $event)"
        [attr.aria-label]="'language' | translate"
        [attr.aria-expanded]="openPopup === 'language'"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <circle cx="12" cy="12" r="10" />
          <line x1="2" y1="12" x2="22" y2="12" />
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
        </svg>
      </button>
    }
  </div>
</header>

<nav class="t1-mbot" [attr.aria-label]="'template1_sidebar_nav' | translate">
  @for (item of mobilePrimaryNav; track item.id) {
    <button
      type="button"
      class="t1-mbot__item"
      [class.t1-mbot__item--active]="item.id === activeNavId"
      [attr.aria-current]="item.id === activeNavId ? 'page' : null"
      (click)="navigate(item)"
    >
      <span class="t1-mbot__icon">
        <ng-container *ngTemplateOutlet="navIcon; context: { $implicit: item.id }"></ng-container>
      </span>
      <span class="t1-mbot__label">{{ item.labelKey | translate }}</span>
      @if (item.hasLiveDot) {
        <span class="t1-mbot__dot" aria-hidden="true"></span>
      }
    </button>
  }

  <button
    type="button"
    class="t1-mbot__item"
    [class.t1-mbot__item--active]="openPopup === 'profile'"
    (click)="togglePopup('profile', $event)"
    [attr.aria-expanded]="openPopup === 'profile'"
  >
    <span class="t1-mbot__icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    </span>
    <span class="t1-mbot__label">{{ profileLabelKey | translate }}</span>
  </button>
</nav>

<!--
  Mobile search results. The input itself now lives inline in the top bar
  (`.t1-mtop__search`, the shared `<stupa-common-search-bar>`) instead of a
  separate sheet — this is only the results dropdown underneath it, reading
  the same state the rail's own inline search does. No scrim: the existing
  `document:click`/Escape handlers (`dismissOverlays`) already close this the
  same way they close popups, and the shared search bar's own collapse
  already removes the "nothing else visible" chrome without needing to dim
  the rest of the page.
-->
@if (isMobileSearchOpen && (isSearchLoading || searchResults.length > 0)) {
  <div class="t1-msearch" (click)="$event.stopPropagation()" role="listbox" [attr.aria-label]="'search' | translate">
    @if (isSearchLoading) {
      <div class="t1-rail__search-state">{{ 'loading' | translate }}</div>
    }

    <!-- Tracked by index for the same reason the rail's list is: the API can
         omit `id`, and the list is replaced wholesale per search anyway. -->
    @for (result of searchResults; track $index) {
      <button type="button" class="t1-rail__result" (click)="openResult(result)">
        <span class="t1-rail__result-name">{{ result.name }}</span>
        <span class="t1-rail__result-meta">
          <span class="t1-rail__result-type">{{ result.type }}</span>
          @if (result.isLive) {
            <span class="t1-rail__result-live">{{ 'live' | translate }}</span>
          }
        </span>
      </button>
    }
  </div>
}

<!--
  Popups live OUTSIDE <aside> on purpose: the rail's `backdrop-filter` makes it
  a containing block, which would anchor `position: fixed` children to the rail
  instead of the viewport (and clip them against its overflow).

  On a phone the same popups are restyled into bottom sheets, so they get a
  scrim: a full-width sheet needs a visible "tap here to dismiss" surface,
  where the desktop popup can rely on the document click handler alone.
-->
@if (openPopup !== null) {
  <div class="t1-msheet-scrim" (click)="closePopups()" aria-hidden="true"></div>
}

@if (openPopup === 'language') {
  <div
    class="t1-rail__popup t1-rail__popup--bottom"
    (click)="$event.stopPropagation()"
    role="menu"
  >
    <div class="t1-rail__popup-header">{{ 'preferred_language' | translate }}</div>
    @for (lang of languages; track lang.code) {
      <button
        type="button"
        class="t1-rail__popup-item"
        [class.t1-rail__popup-item--selected]="lang.code === currentLang"
        (click)="selectLanguage(lang.code)"
        role="menuitem"
      >
        {{ lang.name }}
      </button>
    }
  </div>
}

@if (openPopup === 'theme') {
  <div
    class="t1-rail__popup t1-rail__popup--bottom"
    (click)="$event.stopPropagation()"
    role="menu"
  >
    <div class="t1-rail__popup-header">{{ 'template1_sidebar_skin' | translate }}</div>
    @for (option of themeOptions; track option.value) {
      <button
        type="button"
        class="t1-rail__popup-item t1-rail__theme-item"
        [class.t1-rail__popup-item--selected]="option.value === currentTheme"
        (click)="selectTheme(option.value)"
        role="menuitemradio"
        [attr.aria-checked]="option.value === currentTheme"
      >
        <span class="t1-rail__theme-swatch" [class]="'t1-rail__theme-swatch--' + option.value" aria-hidden="true"></span>
        <span class="t1-rail__theme-label">{{ option.labelKey | translate }}</span>
        @if (option.value === currentTheme) {
          <svg class="t1-rail__theme-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        }
      </button>
    }
  </div>
}

@if (openPopup === 'textsize') {
  <div
    class="t1-rail__popup t1-rail__popup--bottom t1-text-size-popup"
    (click)="$event.stopPropagation()"
    role="menu"
  >
    <div class="t1-rail__popup-header">{{ 'text_size' | translate }}</div>
    @for (option of textScaleOptions; track option.scale) {
      <button
        type="button"
        class="t1-rail__popup-item t1-rail__text-size"
        [class]="option.previewClass"
        [class.t1-rail__popup-item--selected]="option.scale === currentTextScale()"
        (click)="selectTextScale(option.scale)"
        role="menuitemradio"
        [attr.aria-checked]="option.scale === currentTextScale()"
      >
        {{ option.labelKey | translate }}
      </button>
    }
  </div>
}

@if (openPopup === 'profile') {
  <div
    class="t1-rail__popup t1-rail__popup--bottom"
    (click)="$event.stopPropagation()"
    role="menu"
  >
    <!--
      Rail entries the mobile bottom bar had no slot for. Hidden above the
      mobile breakpoint, where the rail already lists all of them, so this is
      an overflow menu on a phone and dead markup on a desktop.
    -->
    @if (mobileOverflowNav.length > 0) {
      <div class="t1-rail__popup-header t1-mnav-overflow">{{ 'explore' | translate }}</div>
      @for (item of mobileOverflowNav; track item.id) {
        <button
          type="button"
          class="t1-rail__popup-item t1-mnav-overflow"
          [class.t1-rail__popup-item--selected]="item.id === activeNavId"
          (click)="navigate(item)"
          role="menuitem"
        >
          {{ item.labelKey | translate }}
        </button>
      }
    }
    <div class="t1-rail__popup-header">{{ 'my_account' | translate }}</div>
    @for (item of profileMenu; track item.id) {
      <button
        type="button"
        class="t1-rail__popup-item"
        [class.t1-rail__popup-item--danger]="item.danger"
        (click)="runProfileAction(item)"
        role="menuitem"
      >
        {{ item.labelKey | translate }}
      </button>
    }
  </div>
}

@if (searchQuery.length > 0 && (isSearchLoading || searchResults.length > 0)) {
  <div class="t1-rail__popup t1-rail__popup--search" (click)="$event.stopPropagation()">
    <div class="t1-rail__popup-header">{{ 'search' | translate }}</div>

    @if (isSearchLoading) {
      <div class="t1-rail__search-state">{{ 'loading' | translate }}</div>
    }

    <!-- Tracked by index: the API can omit `id`, and duplicate track keys are a
         hard runtime error. The list is replaced wholesale per search anyway. -->
    @for (result of searchResults; track $index) {
      <button type="button" class="t1-rail__result" (click)="openResult(result)">
        <span class="t1-rail__result-name">{{ result.name }}</span>
        <span class="t1-rail__result-meta">
          <span class="t1-rail__result-type">{{ result.type }}</span>
          @if (result.isLive) {
            <span class="t1-rail__result-live">{{ 'live' | translate }}</span>
          }
        </span>
      </button>
    }
  </div>
}
